module.exports = __webpack_public_path__ + "static/media/craft-02.5db4203d.svg";